import React from "react";
import { useNavigate } from "react-router-dom";
import LegalPage, { LegalBackButton } from "./legal/LegalPage";
import { CMS_SLUGS } from "./legal/cmsContent";
import { getStoredToken } from "../utils/auth";

export default function TermsPage() {
  const navigate = useNavigate();
  // Signed-in users open this from the Account page, subscriptions or sound licences; only sign-up accepts the terms here
  const signedIn = Boolean(getStoredToken());

  const handleAccept = () => {
    sessionStorage.setItem("termsAccepted", "true");
    localStorage.setItem("termsAccepted", "true");
    navigate("/signup");
  };

  return (
    <LegalPage
      slug={CMS_SLUGS.TERMS}
      title="Terms & Conditions"
      subtitle={signedIn ? "The terms that apply to your use of Nyawoo." : "Please read these terms carefully before creating your Nyawoo account."}
      cardLabel="Nyawoo user agreement"
      renderActions={({ readToEnd }) => signedIn ? <LegalBackButton /> : (
        <>
          <p className={`mt-3 text-xs text-center ${readToEnd ? "text-[#095228]" : "text-gray-500"}`}>
            {readToEnd ? "Thanks for reading. You can accept the terms now." : "Scroll to the end of the terms to accept them."}
          </p>

          <div className="mt-5 flex flex-col-reverse sm:flex-row gap-3">
            <button
              type="button"
              onClick={() => navigate("/signup")}
              className="h-[56px] flex-1 rounded-xl border border-[#161F28] text-[#161F28] font-medium hover:bg-gray-50"
            >
              Back to Sign Up
            </button>
            <button
              type="button"
              onClick={handleAccept}
              disabled={!readToEnd}
              className="h-[56px] flex-1 rounded-xl bg-[#161F28] hover:bg-[#1B2537]/90 text-white font-medium disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Accept & Continue
            </button>
          </div>
        </>
      )}
    />
  );
}
